import { makeAutoObservable, runInAction } from 'mobx';
import { toast } from 'react-toastify';
import agent from '../api/agent';
import {
  InventoryDelivery_DeliveryPayload,
  OrderRegisterPayLoadType,
  circuitCreationPOST,
} from '../api/types';
import { DeliveryRequest } from '../models/deliveryRequest';
import { store } from './store';
import sendRespectiveEmail from '../models/EmailNew';
import { historyInitialState } from '../models/history';

export default class DeliveryStore {
  allDeliveryRequestRegistry = new Map<string, DeliveryRequest>();

  //order register
  orderRegisterRegistry = new Map<string, any>();
  //approve register
  approveRegistry = new Map<string, any>();
  //assign picker register
  assignPickerRegistry = new Map<string, any>();
  //create order  register
  createOrderRegister = new Map<string, any>();
  //delivery  register
  deliveryRegistry = new Map<string, any>();

  selectedDelivery: DeliveryRequest | undefined = undefined;
  loadingInitial = false;
  loading = false;

  // workLevelsList: { id: string; title: string }[] = [];
  // filmTitleList: { id: string; title: string; print?: string }[] = [];
  hfcMetadata: { name: string; value: string }[] = [];

  constructor() {
    makeAutoObservable(this);
  }

  get alldeliveryitemsByDate() {
    return Array.from(this.allDeliveryRequestRegistry.values());
  }
  get orderRegisterTable() {
    return Array.from(this.orderRegisterRegistry.values());
  }
  get ApproveRegisterTable() {
    return Array.from(this.approveRegistry.values());
  }
  get AssignPickerRegisterTable() {
    return Array.from(this.assignPickerRegistry.values());
  }
  get createOrderTable() {
    return Array.from(this.createOrderRegister.values());
  }
  get deliveryTable() {
    return Array.from(this.deliveryRegistry.values());
  }

  setLoadingInitial = (state: boolean) => {
    this.loadingInitial = state;
  };

  private setAllDelivery = (delivery: DeliveryRequest) => {
    this.allDeliveryRequestRegistry.set(delivery.id, delivery);
  };

  private setOrderRegisterTable = (orderreg: any) => {
    this.orderRegisterRegistry.set(orderreg.id, orderreg);
  };
  private setApproveTable = (orderreg: any) => {
    this.approveRegistry.set(orderreg.id, orderreg);
  };
  private setAssignPickerTable = (orderreg: any) => {
    this.assignPickerRegistry.set(orderreg.id, orderreg);
  };
  private setCreateOrderTable = (orderreg: any) => {
    this.createOrderRegister.set(orderreg.id, orderreg);
  };
  private setDeliveryRegistry = (orderreg: any) => {
    this.deliveryRegistry.set(orderreg.id, orderreg);
  };

  listOrderRegister = async () => {
    try {
      const details = await agent.Order.listOrderRegister();
      this.orderRegisterRegistry = new Map<string, any>();
      details.forEach((deliveryDetails: any) => {
        runInAction(() => {
          this.setOrderRegisterTable(deliveryDetails);
        });
      });
    } catch (err) {
      console.log(err);
    }
  };
  listApproveDelivery = async () => {
    try {
      this.approveRegistry = new Map<string, any>();
      const details = await agent.Order.listApproveDelivery();
      details.forEach((deliveryDetails: any) => {
        runInAction(() => {
          this.setApproveTable(deliveryDetails);
        });
      });
    } catch (err) {
      console.log(err);
    }
  };
  listAssignPickerDelivery = async () => {
    try {
      this.assignPickerRegistry = new Map<string, any>();
      const details = await agent.Order.listAssignPicker();
      details.forEach((deliveryDetails: any) => {
        runInAction(() => {
          this.setAssignPickerTable(deliveryDetails);
        });
      });
    } catch (err) {
      console.log(err);
    }
  };
  deleteAssignPicker = (id: string) => {
    this.assignPickerRegistry = new Map<string, any>();
  };

  listCreateOrder = async () => {
    try {
      this.createOrderRegister = new Map<string, any>();
      const details = await agent.Order.listCreateOrder();

      details.forEach((deliveryDetails: any) => {
        runInAction(() => {
          this.setCreateOrderTable(deliveryDetails);
        });
      });
    } catch (err) {
      console.log(err);
    }
  };
  listDelivery = async () => {
    try {
      this.deliveryRegistry = new Map<string, any>();
      const details = await agent.Order.listDelivery();

      details.forEach((deliveryDetails: any) => {
        runInAction(() => {
          this.setDeliveryRegistry(deliveryDetails);
        });
      });
    } catch (err) {
      console.log(err);
    }
  };

  loadAllDelivery = async () => {
    this.loadingInitial = true;
    try {
      const deliveryDetails = await agent.Deliveries.listAllDelivery();
      deliveryDetails.forEach((deliveryDetails) => {
        runInAction(() => {
          this.setAllDelivery(deliveryDetails);
        });
      });
      this.setLoadingInitial(false);
    } catch (error) {
      runInAction(() => {
        console.log(error);
        this.setLoadingInitial(false);
      });
    }
  };
  deleteOrderRegister = (id: string) => {
    this.orderRegisterRegistry.delete(id);
  };

  OrderRegister = async (id: string, payload: OrderRegisterPayLoadType) => {
    let response;
    try {
      response = await agent.InventoryDelivery.OrderRegister(id, payload);
      return response.data;
    } catch {
      toast.error('Something went wrong ! Please try again');
      return '';
    }
  };

  // getWorkLevelList = async () => {
  //   try {
  //     const response = await agent.InventoryDelivery.listWorkLevel();
  //     runInAction(() => {
  //       this.workLevelsList = response.data;
  //     });
  //   } catch (error) {
  //     toast.error('Unable to fetch WorkLevel Details');
  //   }
  // };

  // getTitleByWorklevel = async (params: { itemGroupId: string }) => {
  //   try {
  //     const response = await agent.InventoryDelivery.filterTitleByWL(params);
  //     runInAction(() => {
  //       this.filmTitleList = response.data;
  //     });
  //   } catch (error) {
  //     toast.error('Unable to fetch Title');
  //   }
  // };

  // outwardReqValidation = async (params: { itemId: string }) => {
  //   try {
  //     const response = await agent.InventoryDelivery.outwardRequestValidation(
  //       params,
  //     );
  //     return response.data;
  //   } catch (error) {
  //     toast.error('Unable to perform Validation');
  //   }
  // };

  outwardDetails = async (params: { itemId: string }) => {
    try {
      const response = await agent.InventoryDelivery.outwardReqDetails(params);
      return response.data;
    } catch (error) {
      toast.error('Unable to fetch item details');
      console.log('API Failed', error);
    }
  };

  ApproveDelivery = async (id: string, approve: boolean, comments: string) => {
    let response;
    try {
      response = await agent.InventoryDelivery.Approve(id, approve, comments);
      return response.data;
    } catch {
      toast.error('Something went wrong ! Please try again');
      return '';
    }
  };

  AssignPicker = async (
    id: string,
    pickerName: string,
    pickerContact: string,
  ) => {
    let response;
    try {
      response = await agent.InventoryDelivery.AssignPicker(
        id,
        pickerName,
        pickerContact,
      );
      return response.data;
    } catch {
      toast.error('Something went wrong ! Please try again');
      return '';
    }
  };

  Delivery = async (
    id: string,
    payload: InventoryDelivery_DeliveryPayload,
    itemId: string,
  ) => {
    let response;
    try {
      response = await agent.InventoryDelivery.Delivery(id, payload);
      toast.success('Asset delivered successfully');
      if (response.data.includes('successfully')) {
        await agent.InventoryDelivery.AssetTrackingStatus(
          itemId,
          'Asset successfully delivered',
        );
      }
      return response.data;
    } catch {
      toast.error('Something went wrong ! Please try again');
      return '';
    }
  };

  hfcDeliveryMetadata = async (params: { itemId: string }) => {
    try {
      const response = await agent.HFC.getMetadatForDelivery(params);
      runInAction(() => {
        this.hfcMetadata = response.data;
      });
    } catch (error) {
      toast.error('Failed to load metadata');
      console.log('API Failed: ', error);
    }
  };

  circuitCreation = async (
    params: { itemId: string },
    itemName: string,
    payload: circuitCreationPOST,
    initialPost: boolean,
  ) => {
    try {
      let boolRes = true;
      const response = await agent.HFC.circuitCreation(params, payload);
      runInAction(async () => {
        if (response.data === 'Okay') {
          toast.success('Circuit created successfully.');
          if (!initialPost) {
            const histpayload={
              ...historyInitialState,
              itemId: params.itemId,
              status:  `${store.userStore.user?.displayName} has initiated a shipping request for the asset "${itemName}" which will be at ${payload.theater}, ${payload.address} from ${payload.deliveryDate}, returning on   ${payload.returnDate}`,
              dateTime: new Date().toISOString(),
              trackerFromTime: new Date().toISOString(),
            }
            await agent.HFC.HFCaddHistory(histpayload)
            sendRespectiveEmail(
              '',
              '',
              'Asset Movement Notification',
              '',
              '',
              '',
              `This is to notify that ${itemName} is moving to ${payload.theater} on ${payload.deliveryDate} and will be returned back on ${payload.returnDate}.`,
            );
          }
        } else {
          toast.info(response.data);
          boolRes = false;
        }
      });
      return boolRes;
    } catch (error) {
      toast.error('Failed to create circuit');
      console.log('API Failed: ', error);
    }
  };

  // create Order Request
}
